import t from"./lib/gif.worker.js";const r=()=>{const t=new Blob([e],{type:"application/javascript"});return URL.createObjectURL(t)},e=t;export{e as GifWorker,r as transformToUrl};
